import React from "react";


export const Loader = () => (
    <div className="container-fluid loader">
        <h1>Loading...</h1>
    </div>
)